var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarMan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 331.594 331.594",
    style: {
      enableBackground: "new 0 0 331.594 331.594"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_62_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1228_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1229_",
    style: {
      fill: "#F3D8B6"
    },
    d: "M248.986,236.042c-18.667-6.681-51.458-11.736-51.458-81.376h-29.23h-5.002 h-29.23c0,69.64-32.791,74.695-51.458,81.376c0,47.368,68.832,48.824,80.688,53.239v1.537c0,0,0.922-0.188,2.501-0.68 c1.579,0.492,2.501,0.68,2.501,0.68v-1.537C180.153,284.866,248.986,283.409,248.986,236.042z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1230_",
    style: {
      fill: "#EEC8A2"
    },
    d: "M197.528,154.666h-29.23h-2.501v135.472c1.579,0.491,2.501,0.68,2.501,0.68 v-1.537c11.856-4.414,80.688-5.871,80.688-53.239C230.319,229.361,197.528,224.306,197.528,154.666z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_55_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1233_",
    style: {
      fill: "#545465"
    },
    d: "M285.326,290.913v40.681H45.363v-40.681c0-30.431,17.377-56.963,40.605-70.913 c6.043-3.641,19.69-7.43,26.844-9.196c5.953-1.488,53.438,12.729,53.438,12.729s48.674-13.218,54.627-11.729 c7.154,1.766,17.802,4.554,23.844,8.196C267.949,233.951,285.326,260.482,285.326,290.913z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1236_",
    style: {
      fill: "#494857"
    },
    d: "M245.627,220c-6.042-3.641-19.69-7.43-26.844-9.196 c-5.953-1.488-52.533,12.729-52.533,12.729l0,0v108.06h119.982v-40.681C286.232,260.482,268.854,233.951,245.627,220z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_52_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1237_",
    style: {
      fill: "#F3DBC4"
    },
    d: "M165.799,176.828c-27.454,0-48.409-23.119-57.799-40.456 s-15.888-79.445,4.34-106.897c19.808-26.883,53.459-13.838,53.459-13.838s33.649-13.045,53.458,13.838 c20.226,27.452,13.726,89.56,4.335,106.897C214.2,153.709,193.247,176.828,165.799,176.828z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1238_",
    style: {
      fill: "#EDCEAE"
    },
    d: "M219.257,29.476c-19.81-26.883-53.458-13.838-53.458-13.838h-0.002v161.191 c0.001,0,0.001,0,0.002,0c27.449,0,48.401-23.119,57.794-40.456C232.983,119.036,239.483,56.928,219.257,29.476z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_45_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1241_",
    style: {
      fill: "#545465"
    },
    d: "M223.252,25.321c-2.159,0.08-12.282-31.303-39.282-24.303 c-18.537,4.806-20.877,7.419-28.12,9.463c-29.41-9.014-57.539,14.472-56.495,36.488c1.759,37.07-4.778,36.505-0.295,49.454 s8.466,23.407,8.466,23.407s0.996,3.565,2.988-16.854s-4.705-31.379,11.137-31.379c52.452,0-19.698,20.372,13.952,20.372 c33.391,0,59.203-27.381,74.92-29.372c15.716-1.992,9.145,19.96,11.137,40.379s2.988,16.854,2.988,16.854s8.92-9.712,8.466-23.407 C232.604,80.969,239.484,24.719,223.252,25.321z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1244_",
    style: {
      fill: "#494857"
    },
    d: "M223.252,25.322c-2.159,0.08-12.282-31.303-39.282-24.303 c-9.171,2.377-14.375,4.218-18.173,5.719V85.04c18.973-8.253,34.142-21.103,44.726-22.443c15.717-1.992,9.145,19.96,11.137,40.379 s2.988,16.854,2.988,16.854s8.92-9.712,8.466-23.407C232.604,80.969,239.484,24.719,223.252,25.322z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_42_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_44_",
    transform: "matrix(0.3543 -0.9351 0.9351 0.3543 45.161 283.6375)",
    style: {
      fill: "#EDCEAE"
    },
    cx: 227.971,
    cy: 109.116,
    rx: 17.187,
    ry: 10.048
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_43_",
    transform: "matrix(0.3543 0.9351 -0.9351 0.3543 168.9501 -26.4359)",
    style: {
      fill: "#F3DBC4"
    },
    cx: 103.618,
    cy: 109.124,
    rx: 17.187,
    ry: 10.048
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_38_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1245_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1246_",
    style: {
      fill: "#FFFFFF"
    },
    points: "213.458,331.594 118.136,331.594 118.136,204.664 165.797,218.388  213.458,204.664  "
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1247_",
    style: {
      fill: "#DFE0E7"
    },
    points: "165.797,218.388 165.797,331.594 213.458,331.594 213.458,204.664  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_35_",
    style: {
      fill: "#494857"
    },
    d: "M126.777,201.164c0,0-32.452,8.501-39.684,18.626 c-7.232,10.124-11.571,23.865-11.571,23.865l28.204,10.124l-20.887,20.344l28.811,57.366h26.791c0,0-20.868-72.454-21.331-97.992 C116.959,225.13,126.777,201.164,126.777,201.164z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1251_",
    style: {
      fill: "#3B3A47"
    },
    d: "M204.817,201.164c0,0,32.452,8.501,39.684,18.626 c7.232,10.124,11.571,23.865,11.571,23.865l-28.204,10.124l20.887,20.344l-28.15,57.366h-26.791c0,0,20.207-72.454,20.669-97.992 C214.635,225.13,204.817,201.164,204.817,201.164z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarMan);
export default __webpack_public_path__ + "static/media/avatar-man.8c16d5d5fe925ea8cd36e255bedef3cd.svg";
export { ForwardRef as ReactComponent };